import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { sanitizeHtml } from "@/lib/sanitize";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Error"))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <>
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-10 md:py-16" data-testid={`cms-page-${slug}`}>
        {loading && (
          <div className="space-y-3">
            <div className="h-8 bg-[color:var(--surface-2)] rounded animate-pulse w-1/2" />
            <div className="h-4 bg-[color:var(--surface-2)] rounded animate-pulse" />
            <div className="h-4 bg-[color:var(--surface-2)] rounded animate-pulse w-5/6" />
          </div>
        )}
        {!loading && error && (
          <div className="py-20 text-center">
            <h1 className="font-headline text-3xl mb-3">Página no encontrada</h1>
            <Link to="/" className="accent-text">← Volver al inicio</Link>
          </div>
        )}
        {!loading && page && (
          <>
            <p className="overline accent-text mb-2">POPU.NEWS</p>
            <h1 className="font-headline uppercase text-3xl md:text-5xl leading-tight mb-6" data-testid="cms-page-title">
              {page.title}
            </h1>
            <article
              className="article-body prose prose-lg max-w-none"
              data-testid="cms-page-body"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.body) }}
            />
          </>
        )}
      </main>
      <Footer />
    </>
  );
}
